import { prod } from '../catalog/slice/prod';
import store from '../store';

const _trackFav = (node, withTxt) => {
  const btn = document.getElementById(node);
  if (btn === null) {
    return;
  }

  const id = btn.dataset.id;

  const toggle = (vals) => {
    const inList = vals.find((v) => v === id);
    const span = btn.querySelector('span');
    if (inList) {
      btn.classList.add('active');
      if (withTxt) {
        span.innerHTML = 'В избранном';
      }
    } else {
      btn.classList.remove('active');
      if (withTxt) {
        span.innerHTML = 'В избранное';
      }
    }
  };

  const onClick = (evt) => {
    store.dispatch(prod.actions.favour(id));
    evt.preventDefault();
    evt.stopPropagation();
    return false;
  };

  store.subscribe(() => toggle(store.getState().prod.favour));
  btn.addEventListener('click', onClick);
};

export const trackFav = () => {
  _trackFav('prod-favour', true);
  _trackFav('prod-favour-mob', false);
};

export const trackCompare = () => {
  const btn = document.getElementById('prod-compare');
  if (btn === null) {
    return;
  }

  const id = btn.dataset.id;
  const onClick = (evt) => {
    store.dispatch(prod.actions.compare(id));
    btn.removeEventListener('click', onClick);
    evt.preventDefault();
    evt.stopPropagation();
    return false;
  };

  const redirectToCompare = (evt) => {
    window.location.href = '/compare';
    evt.preventDefault();
    evt.stopPropagation();
    return false;
  };

  const toggle = (vals) => {
    const inList = vals.find((v) => v === id);
    const span = btn.querySelector('span');
    if (inList) {
      btn.classList.add('active');
      span.innerHTML = 'Перейти в сравнение';
      btn.removeEventListener('click', onClick);
      btn.addEventListener('click', redirectToCompare);
    } else {
      btn.classList.remove('active');
      span.innerHTML = 'В сравнение';
      btn.removeEventListener('click', redirectToCompare);
      btn.addEventListener('click', onClick);
    }
  };

  store.subscribe(() => toggle(store.getState().prod.compare));
};

export const trackShare = () => {
  const cont = document.getElementById('prod-share-container');
  if (cont === null) {
    return;
  }

  const btn = document.getElementById('prod-share');
  if (btn === null) {
    return;
  }

  const items = document.getElementById('prod-share-items');
  if (items === null) {
    return;
  }

  const toggle = () => cont.classList.toggle('clinker-share__act');
  btn.addEventListener('click', toggle);

  const hide = () => {};
  return hide;
};
